import { useSyncExternalStore } from "react";

// Whether the checkout panel is open, kept outside React so a card's "(n)" and the
// page's checkout button can both open it. The last placed order is kept in
// sessionStorage so the return page still knows it if the return nonce is spent.

let open = false;
const listeners = new Set<() => void>();

export const checkoutPanel = {
  open() {
    open = true;
    listeners.forEach((l) => l());
  },
  close() {
    open = false;
    listeners.forEach((l) => l());
  },
};

export function useCheckoutOpen(): boolean {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => {
        listeners.delete(l);
      };
    },
    () => open,
    () => false,
  );
}

const LAST_ORDER_KEY = "n450s.marketplace.lastOrder";

export interface LastOrder {
  order_id: string;
  order_token: string;
}

export function rememberOrder(order: LastOrder) {
  try {
    window.sessionStorage.setItem(LAST_ORDER_KEY, JSON.stringify(order));
  } catch {
    // private mode: the return page falls back to the nonce only
  }
}

export function lastOrder(): LastOrder | null {
  try {
    const raw = window.sessionStorage.getItem(LAST_ORDER_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed.order_id === "string" && typeof parsed.order_token === "string" ? parsed : null;
  } catch {
    return null;
  }
}
